module.exports = __webpack_public_path__ + "lato-regular-webfont.5a46ad36d0d6f1109e1c.woff";


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/resources/layout/fonts/lato-regular-webfont.woff
// module id = ../../../../../resources/layout/fonts/lato-regular-webfont.woff
// module chunks = styles